import { Face, Groups } from '@mui/icons-material';
import FaceEditionContextProvider from 'pages/RecognitionPages/context/FaceEditionContextProvider';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const RecognitionGroupsList = lazy(() => import('pages/RecognitionPages/Groups'));
const RecognitionsPage = lazy(() => import('pages/RecognitionPages/Recognitions'));

export const faceRecognitionRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'Reconhecimento Facial',
		key: 'face-recognition-management',
		icon: <Face />,
		protected: true,
		collapse: [
			{
				type: 'collapse',
				name: 'routersNames.registerFaces',
				key: 'face-recognition',
				icon: <Face />,
				route: `${DEFAULT_ROUTE}/recognitions`,
        permissionId: [Permissions.FACE_REGISTER],
        component: (
					<FaceEditionContextProvider>
						<RecognitionsPage />
					</FaceEditionContextProvider>
				),
				protected: true,
			},
			{
				type: 'collapse',
				name: 'Grupos Faciais',
				key: 'face-groups',
				icon: <Groups />,
				route: `${DEFAULT_ROUTE}/facegroups`,
				permissionId: [Permissions.FACE_REGISTER],
				component: (
					<FaceEditionContextProvider>
						<RecognitionGroupsList />
					</FaceEditionContextProvider>
				),
				protected: true,
			},
		],
	},
];
